import React from 'react'
import styled from 'styled-components'

import { BackGroundGradientProps } from '.'

/**
 * 共済系用メイン画面の背景
 */
const KsBackground: React.FC<BackGroundGradientProps> = (props) => {
  return <StyledKsBackground {...props} />
}

export const StyledKsBackground = styled.div<{
  background?: string
}>`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  min-height: 100%;
  margin: 0;
  background: ${(props): string =>
    props.background ? props.background : 'var(--color-content-background)'};
`

export default KsBackground
